export const truncateString = (str, maxLength) => {
    if (str && str.length && str.length > maxLength) {
        return str.slice(0, maxLength - 3) + '...';
    } else {
        return str;
    }
}